import React from "react"

import useMediaQuery from "../utils/useMediaQuery"
import LearnProducts from "../components/organisms/learn-products/learn-products";
import PageLayout from "./../components/templates/page-layout/page-layout"

export default function LearnPage() {
  const isMobile = useMediaQuery()

  return (
    <PageLayout>
    <div>
      <LearnProducts/>
    </div>
  </PageLayout>
)
}
